import { ReactNode } from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Lottie } from '@app/core';
import animationData from '@app/illu/Lottie/check.json';

const ANIMATION_SIZE = 230;
const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    whiteSpace: 'pre-line',
  },
  subtitle: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
    marginTop: theme.marginBase * 3,
  },
  animationOverflowBox: {
    position: 'relative',
    overflow: 'hidden',
    height: theme.marginBase * 19,
    width: '100%',
  },
  imageContainer: {
    position: 'absolute',
    top: (theme.marginBase * 19 - ANIMATION_SIZE) / 2,
    right: 0,
    left: 0,
    height: ANIMATION_SIZE,
    display: 'flex',
    justifyContent: 'center',
  },
  centered: {
    textAlign: 'center',
  },
}));

interface Props {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  centered?: boolean;
}

export const SuccessScreen = ({
  title,
  description,
  centered,
  children,
}: Props) => {
  const theme: any = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classnames({
        [classes.centered]: !!centered,
      })}
    >
      <div className={classes.animationOverflowBox}>
        <div className={classes.imageContainer}>
          <Lottie
            animationData={animationData}
            play
            loop={false}
            style={{ width: ANIMATION_SIZE, height: ANIMATION_SIZE }}
          />
        </div>
      </div>
      <h1 className={classes.title}>{title}</h1>
      {description && <p className={classes.subtitle}>{description}</p>}
      {children}
    </div>
  );
};
